/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

var isObject = require('./_is-object');
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};




//////////////////
// WEBPACK FOOTER
// ./~/babel-polyfill/~/core-js/modules/_validate-collection.js
// module id = 107
// module chunks = 60